<template>
  <div>
    <h2>Breadscrumbs</h2>
    <div>
      <!-- breadcrumbs -->
      <div class="breadscrumbs">
        <router-link to="/product-download" class="breadscrumbs-item"
          >Product Download</router-link
        >
        <v-icon>chevron_right</v-icon>
        <router-link
          to="/product-download/create"
          class="breadscrumbs-item active"
          >Create</router-link
        >
      </div>
      <!-- breadcrumbs -->
      <Breadscrumbs
        :links="[
          { name: 'Product Download', to: { path: 'product-download' } },
          { name: 'Create', to: { path: 'product-download/create' } },
        ]"
      ></Breadscrumbs>
    </div>

    <h2>Page Actions</h2>
    <div>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>編輯Product Download</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5">
          <span>取消</span>
        </button>
        <button class="btn btn-primary">
          <span>儲存</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    Breadscrumbs,
  },
};
</script>

<style></style>
